import * as React from "react";

export const ShortFormTnc: React.FunctionComponent = () => {
  return (
    <div className="short-form-tnc">
      <p>
        <span>{`By creating an account, you agree to our `}</span>
        <a href="/terms">{`terms and conditions`}</a>
        <span>{`.`}</span>
      </p>
    </div>
  );
};
